// extracted by mini-css-extract-plugin
export var dropdownContainer = "_on-0";
export var leftAlign = "_on-4";
export var listItem = "_on-2";
export var listItemWrapper = "_on-1";
export var operationText = "_on-3";